<template>
  <div>
    <div class="note d-flex font font--note font--color_note mb-7">
      <div style="margin-right: 10px">
        <v-icon size="18px" class="font--color_warning">{{ "mdi-information-outline" }}</v-icon>
      </div>
      <div v-if="companyFound">
        Вы являетесь клиентом Модульбанка, данные для вывода вознаграждения мы заполнили автоматически, при
        необходимости вы сможете изменить их здесь или в настройках.
      </div>
      <div v-else>
        Данные паспорта и счёта необходимы для выплаты вознаграждения. Вы можете заполнить их позже. Но забрать
        вознаграждение, пока они не будут заполнены, не сможете.
      </div>
    </div>

    <v-form v-model="bankValid" v-on:submit.prevent>
      <BankSearch v-model="localBank" style="margin-bottom: 16px" :rules="[rules.required('')]" dense />
    </v-form>

    <v-form ref="ulForm" v-model="ulValid" v-if="isUL">
      <v-text-field
        style="margin-bottom: 10px"
        :rules="[rules.required('Введите номер счета'), rules.acc20, rules.acc]"
        outlined
        required
        name="acc"
        label="Счёт получателя"
        v-mask="'##### ### # #### #######'"
        v-model="acc"
        type="text"
        dense
      ></v-text-field>
      <h4 style="margin-bottom: 14px" class="font font--h2 h4">Выберите систему налогообложения</h4>
      <v-select
        :menu-props="{ bottom: true, offsetY: true }"
        style="margin-bottom: 10px"
        :rules="[rules.required('Выберите систему налогообложения')]"
        required
        v-model="tax_type"
        :items="tax_types"
        label="Система налогообложения"
        outlined
        dense
      ></v-select>
    </v-form>
    <v-form ref="flForm" v-model="flValid" v-else-if="isFL">
      <v-row>
        <v-col cols="12">
          <v-text-field
            :rules="[rules.required('Введите номер счета'), rules.acc20, rules.acc]"
            v-mask="'##### ### # #### #######'"
            v-model="acc"
            outlined
            name="acc"
            label="Счёт получателя"
            dense
          />
        </v-col>
      </v-row>
    </v-form>

    <div v-if="extraReqIsNotFilled" class="mb-10">
      <v-layout column>
        <v-row>
          <v-col>
            <h4 style="margin-bottom: 14px" class="font font--h2">Дополнительная информация</h4>
          </v-col>
        </v-row>
        <v-form ref="extraRequisitesForm" v-model="extraRequisitesValid">
          <v-row align-center>
            <v-col sm="3" cols="12">
              <span class="d-flex align-center font font--color_light">
                Город нахождения <span class="profile-is-not-filled"></span>
              </span>
            </v-col>
            <v-col sm="9" cols="12">
              <city-search v-model="localCity" dense :rules="[rules.required('Необходимо заполнить')]" />
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="3" cols="12">
              <span class="d-flex align-center font font--color_light">Ссылки на ресурсы</span>
            </v-col>
            <v-col sm="9" cols="12">
              <v-textarea v-model="localLinks" counter="2048" outlined no-resize />
            </v-col>
          </v-row>
        </v-form>
      </v-layout>
    </div>

    <!-- FIXME: убрать false когда починят бек -->
    <template v-if="!companyFound && false">
      <h4 style="margin-bottom: 14px" class="font font--h2 h4">
        Загрузите фото паспорта{{ isUL ? " директора" : " и СНИЛС" }}
      </h4>
      <div class="d-flex files">
        <div>
          <FileUpload
            @attachment-file-add="addFile"
            @file-delete="$store.dispatch('profile/deleteFile', $event)"
            :file="passport_1"
            label="Первый разворот паспорта"
            name="passport_1"
          />
        </div>
        <div>
          <FileUpload
            @attachment-file-add="addFile"
            @file-delete="$store.dispatch('profile/deleteFile', $event)"
            :file="passport_2"
            label="Страница со штампом регистрации"
            name="passport_2"
          />
        </div>
        <div>
          <FileUpload
            @attachment-file-add="addFile"
            @file-delete="$store.dispatch('profile/deleteFile', $event)"
            :file="snils_file"
            label="Сторона с номером СНИЛС"
            name="snils"
            v-if="isFL"
          />
        </div>
      </div>
    </template>

    <div class="d-sm-flex justify-end">
      <v-btn
        @click.native="skipStep"
        to="/cabinet/main"
        :block="$vuetify.breakpoint.xsOnly"
        x-large
        text
        exact
        class="mr-sm-2 mb-2 mb-sm-0"
        color="primary"
        >заполнить позже</v-btn
      >
      <v-btn @click="send" :block="$vuetify.breakpoint.xsOnly" :disabled="!valid" x-large color="primary"
        >Сохранить</v-btn
      >
    </div>
  </div>
</template>

<script>
import BankSearch from "@/components/common/BankSearch";
import { mapActions, mapGetters, mapState } from "vuex";
import { mask } from "vue-the-mask";
import { validateInn, validateAcc } from "@/utils/helpers";

export default {
  components: {
    BankSearch,
    CitySearch: () => import("@/components/common/CitySearch.vue"),
  },
  directives: { mask },

  data() {
    return {
      tax_types: [
        { text: "ОСН — общая система налогообложения", value: "osn" },
        { text: "УСН — упрощенная система налогообложения", value: "usn" },
        { text: "ПСН — патентная система налогообложения", value: "psn" },
        { text: "ЕНВД — единый налог на вмененный доход", value: "envd" },
        { text: "ЕСХН — единый сельскохозяйственный налог", value: "eshn" },
      ],
      flValid: false,
      ulValid: false,
      bankValid: false,
      extraRequisitesValid: false,
      rules: {
        required: (msg) => (v) => !!v || msg,
        inn: (v) => validateInn(v) || "Введите корректный ИНН",
        acc20: () => this.clearAcc.length === 20 || "Счёт получателя должен содержать 20 цифр",
        acc: () =>
          validateAcc(this.clearAcc, this.localBic) ||
          "Неверная контрольная цифра. Внимательно проверьте БИК и номер счёта",
      },
      localLinks: undefined,
      localCity: undefined,
    };
  },
  watch: {
    localBank() {
      if (this.isFL) {
        this.$refs.flForm.inputs.forEach((i) => {
          if (i.$attrs.name === "acc") {
            i.validate();
          }
        });
      }
      if (this.isUL) {
        this.$refs.ulForm.inputs.forEach((i) => {
          if (i.$attrs.name === "acc") {
            i.validate();
          }
        });
      }
    },
  },
  methods: {
    ...mapActions("profile", ["updateBankInfo", "updateProfile"]),

    addFile(data) {
      data.oid = this.profile_id;
      this.$store.dispatch("profile/addFile", data);
    },
    skipStep() {
      console.log("skip step");
      this.$store.commit("profile/setShowStepper", false);
      this.$store.dispatch("profile/get");
      this.$store.dispatch("bid/getBids");
    },

    send() {
      Promise.all([
        this.updateProfile({
          extra_requisites: {
            city: this.localCity?.city_name,
            links: this.localLinks,
          }
        }),
        this.updateBankInfo()
      ]);
    }
  },
  computed: {
    ...mapState("profile", ["companyFound", "files", "profile_id", "bank"]),
    ...mapGetters({
      clearAcc: "profile/acc",
      bic: "profile/bic",
      isUL: "profile/isUL",
      isFL: "profile/isFL",
      extraReqIsNotFilled: "profile/extraReqIsNotFilled",
    }),
    localBank: {
      get() {
        return this.bank;
      },
      set(bank) {
        this.$store.commit("profile/setBank", bank);
      },
    },
    localBic() {
      return !!this.localBank && this.localBank.bic;
    },
    valid() {
      return ((this.flValid && this.isFL) || (this.ulValid && this.isUL)) && this.bankValid && this.extraRequisitesValid;
    },
    passport_1() {
      return this.files.find((file) => file.doc_type === "passport_1") || null;
    },
    passport_2() {
      return this.files.find((file) => file.doc_type === "passport_2") || null;
    },
    snils_file() {
      return this.files.find((file) => file.doc_type === "snils") || null;
    },
    tax_type: {
      get() {
        return this.$store.state.profile.tax_type;
      },
      set(value) {
        this.$store.commit("profile/set", { type: "tax_type", value });
      },
    },
    acc: {
      get() {
        return this.$store.state.profile.acc;
      },
      set(value) {
        this.$store.commit("profile/set", { type: "acc", value });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.note {
  padding: 14px 20px;
  background: #fcf2ce;
  border-radius: 3px;
  .font--color_warning {
    color: #d2aa0f;
  }
}

.files {
  flex-wrap: wrap;
  margin: 0 -6px 26px;
  & > div {
    margin: 6px;
    flex-basis: 189px;
  }
}
@media (max-width: 600px) {
  .files {
    flex-direction: column;
    & > div {
      margin: 0px;
      flex-basis: 150px;
    }
  }
  .h4 {
    text-align: center;
  }
}
</style>
